import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type CreateAttributeRequest = InferRequestType<
  typeof apiClient.attributes.$post
>['json']
type CreateAttributeResponse = InferResponseType<
  typeof apiClient.attributes.$post
>

export const useCreateAttribute = (
  options?: UseMutationOptions<
    CreateAttributeResponse,
    Error,
    CreateAttributeRequest
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.attributes
        .$post({
          json: variables,
        })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['attribute-create'],
    ...options,
  })
